import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import api from 'api';
import Util from 'utility';
import { __ } from 'locale';
import { addMeal, addTraining, openModal, closeModal } from "../../../actions/index";
import DialogNewMeal from '../DialogNewMeal';
import MealItem from './MealItem';
import TrainingItem from './TrainingItem';

function LectureTaskDayPlan({ date, onChange }) {
    const data = useSelector(state => state);
    const dispatch = useDispatch();

    const [activePanel, setActivePanel] = useState({ type: '', key: '' });
    const [foodGroupVisibility, setFoodGroupVisibility] = useState({});
    const [focusedAmountInputId, setFocusedAmountInputId] = useState(0);
    const [focusedAmountInputValue, setFocusedAmountInputValue] = useState('');
    const [currentMouseOverHour, setCurrentMouseOverHour] = useState(-1);
    const [currentMouseOverMinute, setCurrentMouseOverMinute] = useState(0);

    const hourRefs = useRef({});

    const togglePanel = (type, key) =>
        setActivePanel(prev => prev.type === type && prev.key === key ? { type: '', key: '' } : { type, key });
    const closePanel = () => setActivePanel({ type: '', key: '' });

    const toggleFoodGroupVisibility = (fg) => {
        setFoodGroupVisibility(prev => {
            const next = { ...prev };
            if (typeof next[fg] === 'undefined') next[fg] = 1;
            next[fg] = 1 - next[fg];
            return next;
        });
    };

    const handleFoodAmountFocus = (e, food) => {
        e.target.select();
        setFocusedAmountInputId(food.id);
        setFocusedAmountInputValue(parseFloat(food.weight) + '');
    };

    const handleFoodAmountChange = (e) => setFocusedAmountInputValue(e.target.value);

    const handleFoodAmountBlur = () => {
        setFocusedAmountInputId(0);
        setFocusedAmountInputValue('');
    };

    const saveProgress = () => {
        if (data.titles[data.activeMealHash] === '') {
            for (let g in data.foodGroups[data.activeMealHash]) {
                if (data.titles[data.activeMealHash] === '') {
                    data.titles[data.activeMealHash] = data.foodGroups[data.activeMealHash][g].title;
                }
            }
        }

        let dateParsed = data.plannerDate;
        if (Util.isLectureLikeMode(data.appMode)) dateParsed = new Date('2000-01-01');

        const dateUTC = new Date(Date.UTC(
            dateParsed.getFullYear(), dateParsed.getMonth(), dateParsed.getDate(),
            dateParsed.getHours(), dateParsed.getMinutes(), dateParsed.getSeconds()
        ));
        const dayTimestamp = Math.floor(dateUTC.getTime() / 1000);

        const saveData = JSON.stringify({
            meals: JSON.stringify(data.meals),
            groups: JSON.stringify(data.foodGroups),
            foods: JSON.stringify(data.foods),
            modifications: JSON.stringify(data.modifications),
            titles: JSON.stringify(data.titles),
            desciptions: JSON.stringify(data.desciptions),
            activities: JSON.stringify(data.activities),
            trainings: JSON.stringify(data.trainings),
            dayTimestamp: JSON.stringify(dayTimestamp),
            energyOutputSettings: JSON.stringify(data.energyOutputSettings),
        });

        api('save/dayplan', { post: true, data: saveData });
    };

    const saveAndUpdateEvaluation = () => {
        saveProgress();
        Util.doLoadDayEvaluation();
    };

    const onHourMouseMove = (e) => {
        e.preventDefault();
        if (e.target !== e.currentTarget) return;
        const hour = e.target.getAttribute('data-hour') * 1;
        const height = hourRefs.current[hour]?.clientHeight || 1;
        let minute = Math.round((e.nativeEvent.offsetY / height) * 60);
        minute = Math.max(0, Math.min(55, Math.round(minute / 5) * 5));
        setCurrentMouseOverHour(hour);
        setCurrentMouseOverMinute(minute);
    };

    const onHourMouseLeave = () => {
        setCurrentMouseOverHour(-1);
        setCurrentMouseOverMinute(0);
    };

    const doAddMealType = (addData) => {
        if (addData.type === 'meal') {
            const params = {
                mealId: addData.mealId,
                mealLength: 0,
                startHour: addData.hour,
                startMinute: addData.minute,
                profiles: [Util.getActiveProfileId()]
            };
            const hash = params.mealId + '|' + params.profiles.sort((a, b) => a - b).join(',');
            if (typeof data.meals[hash] !== 'undefined') {
                alert("Tento chod s vybranými profily už máte přidán. Zvolte prosím jiný typ chodu, nebo jiný profil / profily.");
                return;
            }
            dispatch(addMeal(params));
        }

        if (addData.type === 'drink_regime') {
            let profileId = Util.getActiveProfileId();
            if (typeof data.appModeData.profileId === 'number') profileId = data.appModeData.profileId;
            dispatch(addMeal({ mealId: 50, mealLength: 0, startHour: addData.hour, startMinute: addData.minute, profiles: [profileId] }));
        }

        if (addData.type === 'activity') {
            dispatch(addTraining({
                start: addData.hour + ':' + addData.minute,
                length: addData.activityLength,
                description: addData.activityTitle,
                profiles: [Util.getActiveProfileId()]
            }));
        }

        dispatch(closeModal());
        saveAndUpdateEvaluation();
    };

    const onAddMealClick = (e) => {
        e.preventDefault();
        if (e.target !== e.currentTarget) return;
        const hour = e.target.getAttribute('data-hour') * 1;
        const height = hourRefs.current[hour]?.clientHeight || 1;
        let minute = Math.round((e.nativeEvent.offsetY / height) * 60);
        minute = Math.round(minute / 5) * 5;
        const title = Util.getLang() === 'sk' ? 'Pridať chod, pitný režim alebo aktivitu' : 'Přidat chod, pitný režim nebo aktivitu';
        dispatch(openModal({ title, content: <DialogNewMeal selectedHour={hour} selectedMinute={minute} onAddMeal={doAddMealType} /> }));
    };

    let mealsAreEditable = true;
    if (typeof data.lectureTaskData === 'object') {
        const taskData = data.lectureTaskData;
        if (typeof taskData?.lecture_data !== 'undefined') {
            const mealsAreEmpty = taskData.lecture_data.meal_types.every(mt => mt.type === "0");
            if (!mealsAreEmpty) mealsAreEditable = false;
        }
    }

    const hourCls = 'cursor-pointer flex flex-col relative transition-all duration-150 min-h-10 border-t border-dashed border-slate-200 hover:border-solid hover:border-slate-300 [&>span]:absolute [&>span]:left-0 [&>span]:top-[-0.55em] [&>span]:w-[50px] [&>span]:pr-2 [&>span]:text-right [&>span]:bg-slate-50 [&>span]:text-slate-400 [&>span]:text-xs [&>span]:leading-none hover:[&>span]:text-slate-600 hover:[&>span]:font-medium';

    const commonProps = {
        activePanel, togglePanel, closePanel,
        foodGroupVisibility,
        onToggleFoodGroupVisibility: toggleFoodGroupVisibility,
        focusedAmountInputId,
        focusedAmountInputValue,
        onAmountFocus: handleFoodAmountFocus,
        onAmountChange: handleFoodAmountChange,
        onAmountBlur: handleFoodAmountBlur,
        onSave: saveProgress,
        onSaveAndUpdate: saveAndUpdateEvaluation,
        onChange,
    };

    let dayPlanHours = [];
    for (let hour = 0; hour < 24; hour++) {
        let hourItems = [];

        for (let mh in data.meals) {
            if (data.meals[mh].startHour == hour) {
                hourItems.push({ type: 'meal', mealHash: mh, startMinute: data.meals[mh].startMinute });
            }
        }

        for (let trainingId = 1; trainingId <= 10; trainingId++) {
            const training = data.trainings[trainingId];
            if (!training || training.length === 0 || training.start === '') continue;
            const [tH, tM] = training.start.split(':');
            if (tH * 1 !== hour) continue;
            hourItems.push({ type: 'training', data: { ...training, id: trainingId, startHour: tH * 1, startMinute: tM * 1 }, startMinute: tM * 1 });
        }

        hourItems.sort((a, b) => a.startMinute - b.startMinute);

        const hourItemsResult = hourItems.map(item =>
            item.type === 'meal'
                ? <MealItem key={item.mealHash} mealHash={item.mealHash} mealsAreEditable={mealsAreEditable} {...commonProps} />
                : <TrainingItem key={item.data.id} training={item.data} />
        );

        const addCurrentHour = data.plannerViewMode !== 1 || hourItemsResult.length > 0;
        if (!addCurrentHour) continue;

        let hourFmt = hour >= 10 ? hour + ':00' : '0' + hour + ':00';
        if (currentMouseOverHour === hour) {
            const spanH = hour >= 10 ? hour : '0' + hour;
            const spanM = currentMouseOverMinute >= 10 ? currentMouseOverMinute : '0' + currentMouseOverMinute;
            hourFmt = spanH + ':' + spanM;
        }

        dayPlanHours.push(
            <div
                key={hour}
                ref={div => { hourRefs.current[hour] = div; }}
                data-hour={hour}
                onClick={onAddMealClick}
                onMouseMove={onHourMouseMove}
                onMouseLeave={onHourMouseLeave}
                className={hourCls}
            >
                <span>{hourFmt}</span>
                {hourItemsResult}
            </div>
        );
    }

    return dayPlanHours;
}

export default LectureTaskDayPlan;
